import React, { useCallback, useMemo, useState } from "react";
import CropFreeIcon from "@material-ui/icons/CropFree";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import useStyles from "./ReservationsStyles";
import { ReservationsHeader } from "./components/ReservationsHeader/ReservationsHeader";
import { ReservationsTitle } from "./components/ReservationsTitle/ReservationsTitle";
import { ReservationsIncome } from "./components/ReservationsIncome/ReservationsIncome";
import Button from "../../components/common/PL/Button/Button";
import DialogConfirmation from "../../components/common/PL/Dialog/DialogConfirmation";
import { goToReservationResult, goToReservationScan } from "./utils/reservationRoutes";
import useSpaceEvents from "./hooks/useSpaceEvents";
import useSpaceScan from "./hooks/useSpaceScan";
import useHidQrScanner from "./hooks/useHidQrScanner";
import { toIncomeItem } from "./utils/spaceEventMappers";
import { useStore } from "../../hooks/useStore";

const Reservations = () => {
  const classes = useStyles();
  const history = useHistory();
  const { authStore } = useStore();
  const { data, loading, error } = useSpaceEvents();
  const { scanQr } = useSpaceScan();
  const [validating, setValidating] = useState(false);
  const [scanError, setScanError] = useState<string | null>(null);

  const items = useMemo(() => (data?.items || []).map(toIncomeItem), [data]);

  const handleScanQr = () => {
    goToReservationScan(history);
  };

  // Lectora de QR (modo teclado): escanear con ella inicia el mismo flujo que la cámara.
  const handleHidScan = useCallback(
    (qr: string) => {
      setValidating(true);
      scanQr(qr)
        .then((scan) => goToReservationResult(history, scan))
        .catch((err: Error) => {
          console.error(err);
          setValidating(false);
          setScanError(err.message);
        });
    },
    [history, scanQr]
  );

  useHidQrScanner({ enabled: !validating && scanError === null, onScan: handleHidScan });

  return (
    <div className={classes.root}>
      <ReservationsHeader />
      <div className={classes.content}>
        <ReservationsTitle name={authStore.user.name} />
        <ReservationsIncome
          items={items}
          total={data?.total ?? items.length}
          loading={loading}
          error={error}
        />
        <Button variant="neutral" size="large" className={classes.scanButton} onClick={handleScanQr}>
          <CropFreeIcon className={classes.scanIcon} />
          Escanear QR
        </Button>
      </div>
      <Backdrop open={validating} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogConfirmation
        open={scanError !== null}
        onClose={() => setScanError(null)}
        onConfirm={() => setScanError(null)}
        title="No pudimos validar el QR"
        message={scanError}
        confirmLabel="Aceptar"
        cancelLabel="Cerrar"
      />
    </div>
  );
};

export default Reservations;
